import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const TokenInvalid = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-[2.5rem] shadow-xl p-10 text-center">
        <XCircle size={80} className="mx-auto text-red-500 mb-6" />
        <h2 className="text-2xl font-black text-slate-900 mb-4">Lien invalide ou expiré</h2>
        <p className="text-slate-500 mb-8 font-medium">
          Ce lien de récupération n'est plus valide. Il a peut-être déjà été utilisé ou les 30 minutes sont écoulées.
        </p>
        <button 
          onClick={() => navigate('/forgot-password')}
          className="flex items-center justify-center gap-2 w-full py-4 bg-slate-900 text-white rounded-2xl font-bold hover:bg-slate-800 transition-all"
        >
          <ArrowLeft size={20} /> Demander un nouveau lien
        </button>
      </div>
    </div>
  );
};

export default TokenInvalid;